module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var specialInstance = ['App - Stage', 'App - Role', 'App - Instance Name', 'App - Instance Number', 'App - Instance ID',
                       'App - Instances Count', 'App - URL', 'App - Parent Instance Name', 'App - Parent Instance Number',
                       'App - Parent Instance ID', 'App - Child Instance Names', 'App - Child Instance Numbers',
                       'App - Child Instance IDs',  'App - Is in Read-Only State', '──────────',
        'Behavior - Last Command was Successful', 'Behavior - Last Command\'s Error Code', 'Behavior - Last Behavior\'s Return Value',
        'Util - Current Time', 'Util - Current Date', 'Util - Server Date','Util - Server Time', 'Util - New Line',  '──────────',
                       'User - First Name', 'User - Last Name', 'User - Full Name', 'User - Email', 'User - Title', 'User - Street Line 1',
                       'User - Street Line 2', 'User - City', 'User - Zip Code', 'User - State/Province', 'User - Country (ISO)',
                       'User - Phone', 'User - Fax', 'User - Mobile Phone', 'User - Skype', 'User - Alternate Email', 'User - Custom ID',
                       'User - Domain Username', 'Gateway - HTTP USER' ];

    ; __append("\r\n<div class=\"row\">\r\n    <div class=\"prop-header\"><span class=\"prop-label\">Instance Name</span></div>\r\n    <div class=\"col-md-12\">\r\n        <div class=\"prop-sublabel\"><input type=\"radio\" name=\"instanceName\" value=\"TextOrNumber\" />Text or Number</div>\r\n    </div>\r\n    <div class=\"col-md-12\" style=\"padding-left: 30px;\">\r\n        <input type=\"text\" name=\"TextOrNumber\" id=\"TextOrNumber\" disabled value=\"")
    ; __append(escapeFn(TextOrNumber))
    ; __append("\" />\r\n    </div>\r\n\r\n    <div class=\"col-md-12 prop-sublabel\">\r\n        <input type=\"radio\" name=\"instanceName\" value=\"ValueOfAField\" /> Value of a Field\r\n\r\n    </div>\r\n\r\n    <div class=\"col-md-12\" style=\"padding-left: 15px;\">\r\n        <div class=\"col-md-8\">\r\n            <input type=\"text\" name=\"ValueOfAField\" id=\"ValueOfAField\" disabled value=\"")
    ; __append(escapeFn(ValueOfAField))
    ; __append("\" />\r\n        </div>\r\n        <div class=\"col-md-4 nopadding\">\r\n            <button id=\"ValueOfAFieldButton\" name=\"ValueOfAFieldButton\" class=\"btn btn-default hvr-glow\"  disabled >Select</button>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"col-md-12 prop-sublabel\">\r\n        <input type=\"radio\" name=\"instanceName\" value=\"Special\" /> Special\r\n    </div>\r\n    <div class=\"col-md-12\" style=\"padding-left: 30px;\">\r\n        <select name=\"Special\" id=\"Special\" disabled>\r\n            ")
    ;  for (var i = 0; i < specialInstance.length; i++) {
            if (specialInstance[i] === '──────────') {
    ; __append("\r\n            <option disabled value=\"")
    ; __append(escapeFn(specialInstance[i].replace(/\s/g, '')))
    ; __append("\">")
    ; __append(escapeFn(specialInstance[i]))
    ; __append("</option>\r\n            ")
    ;     } else { 
    ; __append("\r\n            <option value=\"")
    ; __append(escapeFn(specialInstance[i].replace(/\s/g, '')))
    ; __append("\">")
    ; __append(escapeFn(specialInstance[i]))
    ; __append("</option>\r\n            ")
    ;    }
            }; 
    ; __append("\r\n        </select>\r\n    </div>\r\n\r\n    <div class=\"col-md-12 prop-sublabel\">\r\n        <input type=\"radio\" name=\"instanceName\" value=\"Formula\" /> Formula\r\n    </div>\r\n    <div class=\"col-md-12\" >\r\n        <div class=\"col-md-5\">\r\n            <button name=\"Formula\" id=\"Formula\" class=\"btn btn-default hvr-glow\"  disabled= >Compose</button>\r\n        </div>\r\n        <div class=\"col-md-7\"></div>\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}